exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/babel-polyfill/~/core-js/modules/_wks-ext.js
 ** module id = 543
 ** module chunks = 0
 **/